import { Provider } from 'react-redux';
import Router from './router';
import { AppTheme } from './theme';
import { store } from './redux/store';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import SnackbarProvider from './lib/Snackbar';
import { SnackbarProvider as SnackbarContext } from './lib/SnackbarContext';
import SuccessProvider from './lib/Success';
import { CssVarsProvider } from '@mui/material';
import AppInitializer from './components/core/AppInitializer';

function App() {
	return (
		<HelmetProvider>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<Provider store={store}>
					<CssVarsProvider defaultMode="system">
						<AppInitializer>
							<AppTheme>
								<SnackbarProvider>
									<SnackbarContext>
										<SuccessProvider>
											<Router />
										</SuccessProvider>
									</SnackbarContext>
								</SnackbarProvider>
							</AppTheme>
						</AppInitializer>
					</CssVarsProvider>
				</Provider>
			</LocalizationProvider>
		</HelmetProvider>
	);
}

export default App;
